import React from "react";
import PropTypes from "prop-types";
import styled from "styled-components";
import _ from "lodash";

const MonthsContainer = styled.div`
    display: flex;
    width: 100%;
    align-items: center;
    justify-content: center;
    margin-bottom: 20px;
`;

const Month = styled.div`
    font-size: 18px;
    font-weight: 500;
    line-height: 21px;
    margin: 0 30px;
    color: #47566D !important;
    width: 100px;
    text-align: center;
`;

const Navigation = styled.div`
    width: 30px;
    height: 30px;
    display: flex;
    align-items: center;
    justify-content: center;
    transition: background-color 0.3s;
    
    cursor: ${props => props.disable ? "arrow;" : "pointer"};
    div{
        border-bottom: 2px solid ${props => props.disable ? "#CCCCCC;" : "#47566D"};
        border-left: 2px solid ${props => props.disable ? "#CCCCCC;" : "#47566D"};
    }
    
    &:hover{
        background-color: ${props => props.disable ? "transparent" : "#D2D5D7"};;
        div{
            border-bottom: 2px solid ${props => props.disable ? "#CCCCCC;" : "#47566D"};;
            border-left: 2px solid ${props => props.disable ? "#CCCCCC;" : "#47566D"};;
        }
    }
`;

const NavigationArrow= styled.div`
    border-bottom: 2px solid #CCCCCC;
    border-left: 2px solid  #CCCCCC;
    transform: ${props => props.previous ? "translateX(25%) rotate(45deg);" : "translateX(-25%) rotate(225deg);"}; 
    width: 10px;
    height: 10px;
    display: block;
`;

class Months extends React.Component {

    constructor(props) {
        super(props);
    }


    currentMonthDate(){
        if(this.props.currentMonth === null){
            return this.props.slots[0].date.clone().startOf('month');
        } else {
            return this.props.currentMonth;
        }
    }

    clickNext() {
        if(this.isNextActive()){
            this.props.setMonth(this.currentMonthDate().clone().add(1, 'months'));
        }
    }

    clickPrevious() {
        if(this.isPreviousActive()){
            this.props.setMonth(this.currentMonthDate().clone().subtract(1, 'months'));
        }
    }
    isNextActive(){
        const lastMonth = _.last(this.props.slots).date.clone().subtract(1, 'months').endOf('month');
        return this.currentMonthDate() < lastMonth;
    }
    isPreviousActive(){
        const firstMonth = this.props.slots[0].date.clone().startOf('month');
        return this.currentMonthDate() > firstMonth ;
    }

    render() {
        return (
            <MonthsContainer>
                <Navigation
                    disable={ !this.isPreviousActive() }
                    onClick={ this.clickPrevious.bind(this) }
                >
                    <NavigationArrow previous={true}/>
                </Navigation>

                <Month>{ this.currentMonthDate().format('MMMM') }</Month>

                <Navigation
                    disable={ !this.isNextActive() }
                    onClick={ this.clickNext.bind(this) }
                >
                    <NavigationArrow/>
                </Navigation>
            </MonthsContainer>

        )
    }
}

Months.propTypes = {
    slots: PropTypes.arrayOf(PropTypes.shape({
        key: PropTypes.string,
        date: PropTypes.any,
        slots:  PropTypes.arrayOf(PropTypes.any)
    })),
    currentMonth: PropTypes.any,
    setMonth: PropTypes.func.isRequired
};

export default Months;
